import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Layout
import { MainLayout } from "./components/layout/MainLayout";

// Auth Pages
import Login from "./pages/Login";
import RequestAccess from "./pages/RequestAccess";
import ActivateAccount from "./pages/ActivateAccount";

// Legal Pages
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AboutBuilder from "./pages/AboutBuilder";
import ContactFeedback from "./pages/ContactFeedback";

// Main Pages
import Dashboard from "./pages/Dashboard";
import Tournaments from "./pages/Tournaments";
import MyTournaments from "./pages/MyTournaments";
import ClubEvents from "./pages/ClubEvents";
import FamilyArchers from "./pages/FamilyArchers";
import FamilyDashboard from "./pages/FamilyDashboard";
import Organizations from "./pages/Organizations";
import Results from "./pages/Results";
import Analytics from "./pages/Analytics";
import Notifications from "./pages/Notifications";
import CalendarPage from "./pages/Calendar";
import Profile from "./pages/Profile";

// Admin Pages
import AdminEmails from "./pages/AdminEmails";
import AdminUsers from "./pages/AdminUsers";
import AdminAccessRequests from "./pages/AdminAccessRequests";
import AdminEmailComposer from "./pages/AdminEmailComposer";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/request-access" element={<RequestAccess />} />
          <Route path="/activate" element={<ActivateAccount />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<AboutBuilder />} />

          {/* Protected Routes */}
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/tournaments" element={<Tournaments />} />
            <Route path="/my-tournaments" element={<MyTournaments />} />
            <Route path="/club-events" element={<ClubEvents />} />
            <Route path="/family-archers" element={<FamilyArchers />} />
            <Route path="/family-dashboard" element={<FamilyDashboard />} />
            <Route path="/organizations" element={<Organizations />} />
            <Route path="/results" element={<Results />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/contact" element={<ContactFeedback />} />
            
            {/* Admin Routes */}
            <Route path="/admin/emails" element={<AdminEmails />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/access-requests" element={<AdminAccessRequests />} />
            <Route path="/admin/compose-email" element={<AdminEmailComposer />} />
          </Route>

          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
